import { render } from "./OpenClientMenu.vue?vue&type=template&id=d32dfe06&scoped=true"
import script from "./OpenClientMenu.vue?vue&type=script&lang=js"
export * from "./OpenClientMenu.vue?vue&type=script&lang=js"

import "./OpenClientMenu.vue?vue&type=style&index=0&id=d32dfe06&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32dfe06"]])

export default __exports__